import FormController from 'controllers/form-controller';

export default class CustomerFeedbackFormController extends FormController {
  declare readonly element: HTMLElement;

  declare formValid:boolean;

  connect() {
    super.connect();
  }
}
